import React from 'react';
import * as S from './StatisticsInfo.styles';
import { BaseSpace } from '@app/components/common/BaseSpace/BaseSpace';

interface StatisticsInfoProps {
  name: string;
}

export const FirmInfo: React.FC<StatisticsInfoProps> = ({ name }) => {
  return (
    <BaseSpace direction="vertical" size={8}>
      <S.Title>{name}</S.Title>
    </BaseSpace>
  );
};
